import { Tag } from "primereact/tag";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { ProductIsHiddenColumn_ProductFragment$key } from "@relay/ProductIsHiddenColumn_ProductFragment.graphql";

const PRODUCT_FRAGMENT = graphql`
	fragment ProductIsHiddenColumn_ProductFragment on Product {
		isHidden
	}
`;

type OwnProps = {
	productFragmentRef: ProductIsHiddenColumn_ProductFragment$key;
};

export const ProductIsHiddenColumn = ({ productFragmentRef }: OwnProps) => {
	const { t } = useTranslation("common");
	const product = useFragment<ProductIsHiddenColumn_ProductFragment$key>(
		PRODUCT_FRAGMENT,
		productFragmentRef,
	);

	return (
		<Tag
			value={product.isHidden ? t("actions.yes") : t("actions.no")}
			severity={product.isHidden ? "success" : "info"}
		/>
	);
};
